import forEachParameter from './forEachParameter';
import { InputType } from '../../../InputTypes';

const parameterThatCannotBeChanged = [InputType.HIDDEN, InputType.SUBMIT];

/**
 * Checking if the param for a Form has Changeable parameters.
 *
 * If only hidden params are given, the form is not changeable but can still be submitted.
 * -> this needs to be done for readOnly and disable fields in a form in the near future.
 */
const hasChangeableParameters = parameters => {
  let toReturn = false;
  forEachParameter(parameters).do(parameter => {
    if (parameter) {
      if (!parameterThatCannotBeChanged.includes(parameter.type)) {
        toReturn = true;
      }
    }
  });
  return toReturn;
};

export default hasChangeableParameters;
